import { MenuProvider } from "./MenuContext";
import InnerApp from "./InnerApp.jsx";
import { Provider } from "react-redux";
import store from "./store/store";
import axios from "axios";
import "./App.scss";
import "bootstrap/dist/css/bootstrap.css";

if (process.env.NODE_ENV === "development")
  axios.defaults.baseURL = "http://localhost:9999";

function App() {
  return (
    <>
      <Provider store={store}>
        <MenuProvider>
          <InnerApp />
        </MenuProvider>
      </Provider>
    </>
  );
}

export default App;
